import { IActionFn } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';
import store from '@/store';

// 查询子材料列表
export const querySubMaterials: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setSubMaterials', { ...state.list, loading: true });
    // const res = await $http.post('/material/type/item/child/list', payload);
    const res = await $http.post('/v1/asset/material/children', payload);
    commit('setSubMaterials', { data: res });
  } catch (e) {
    commit('setSubMaterials', { data: [] });
  }
};

// 查询子材料详情
export const querySubDetail: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setSubMaterialDetail', { data: null, loading: true });
    // const res = await $http.get(`/material/type/item/child/detail/${payload}`);
    const res = await $http.get(`/v1/asset/material/children/${payload}/detail`);
    commit('setSubMaterialDetail', { data: res });
  } catch (e) {
    commit('setSubMaterialDetail', { data: null });
  }
};

// 查询颜色参数(这里单独用详情接口,是为了更新颜色信息时,只更新颜色模块的数据,不会导致整个详情页面刷新)
export const querySubColor: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setSubMaterialColor', { data: [], loading: true });
    // const res: { colorInfo: string } = await $http.get(`/material/type/item/child/detail/${payload}`);
    const res: { colorInfo: string } = await $http.get(`/v1/asset/material/children/${payload}/detail`);
    const data = JSON.parse(res.colorInfo || '{}').colors || [];
    commit('setSubMaterialColor', { data, loading: false });
  } catch (e) {
    commit('setSubMaterialColor', { data: [], loading: false });
  }
};

// 添加子材料
export const addSubMaterial: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/material/type/item/add/child', payload);
    await $http.post('/v1/asset/material/addchild', payload);
    store.commit('common/setToast', { visible: true, text: '添加成功, 两秒后跳转' });
  } finally {
    commit('setLoading', false);
  }
};

// 编辑子材料
export const editSubMaterial: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/material/type/item/modify/child', payload);
    await $http.post('/v1/asset/material/modifychild', payload);
    store.commit('common/setToast', { visible: true, text: '编辑成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 删除子材料
export const deleteSubMaterial: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/material/type/item/delete', payload);
    await $http.post('/v1/asset/material/deletechild', payload);
  } finally {
    commit('setConfirm', { visible: false, loading: true });
  }
};
